import { render } from "./TranslationOutput.vue?vue&type=template&id=168b5fdc&scoped=true"
import script from "./TranslationOutput.vue?vue&type=script&lang=js"
export * from "./TranslationOutput.vue?vue&type=script&lang=js"

import "./TranslationOutput.vue?vue&type=style&index=0&id=168b5fdc&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/toki-pona-translator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-168b5fdc"]])

export default __exports__